(() => {
  if (window.cozyVideoGalleryLoaded) return;
  window.cozyVideoGalleryLoaded = true;
  const players = new Map();
  function start(player, manual = false) {
    if (!manual && (!player.visible || player.userPaused || document.hidden)) return;
    player.video.muted = true;
    player.error.hidden = true;
    player.video.play().catch(() => {
      // A tap can start playback if the browser restricts autoplay.
      if (manual && player.video.error) player.error.hidden = false;
    });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const player = players.get(entry.target);
      if (!player) return;
      player.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
      if (player.visible) start(player);
      else player.video.pause();
    });
  }, {threshold: [0, 0.35]}) : null;
  function initialize() {
    document.querySelectorAll('[data-cozy-video-gallery] .cozy-motion__card').forEach(card => {
      const video = card.querySelector('video');
      if (players.has(video)) return;
      const button = card.querySelector('.cozy-motion__toggle');
      const indicator = card.querySelector('.cozy-motion__paused-indicator');
      const error = card.querySelector('.cozy-motion__error');
      const player = {video, button, error, card, userPaused:false, visible:!observer};
      players.set(video, player);
      video.controls = false;
      video.defaultMuted = true;
      video.muted = true;
      video.loop = true;
      button.hidden = false;
      const updateButton = () => {
        button.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} ${button.dataset.videoLabel}`);
        indicator.hidden = !(player.userPaused && video.paused);
      };
      button.addEventListener('click', () => {
        if (video.paused) {
          player.userPaused = false;
          start(player, true);
        } else {
          player.userPaused = true;
          video.pause();
        }
        updateButton();
      });
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('error', () => {error.hidden = false; updateButton();});
      updateButton();
      if (observer) observer.observe(video);
      else start(player);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    players.forEach((player, video) => {
      if (!event.target.contains(video)) return;
      video.pause();
      observer?.unobserve(video);
      players.delete(video);
    });
  });
  document.addEventListener('visibilitychange', () => {
    players.forEach(player => {
      if (document.hidden) player.video.pause();
      else start(player);
    });
  });
})();
